/** @jsxImportSource theme-ui @jsxRuntime classic */
import React from 'react';

import { Text, Link, Box } from '..';

export interface FooterEmailSignupProps {
  rocklistUrl: string;
}

export const FooterEmailSignup = ({
  rocklistUrl,
}: FooterEmailSignupProps): React.JSX.Element => (
  <Box
    sx={{
      width: ['100%', 'unset'],
      mb: [4, null, null, 0],
    }}
  >
    <Text as="h2" variant="footerFirstSectionHeading">
      Sign up for our newsletter
    </Text>
    <Link to={rocklistUrl} variant="footerButton">
      Subscribe Now
    </Link>
  </Box>
);
